// src/lib/create/draftGuard.ts
//
// PURE guard for the Create-New panel draft autosave.
//
// Regression guard (docs/REGRESSIONS.md 2026-07-01): a walkthrough/tutorial must
// NEVER persist a real Create draft. The autosave effect writes directly to
// localStorage['crm.createDrafts.v1'], which BYPASSES the walkthrough's
// window.fetch write-suppression — so a tutorial that opens Create New and types
// left a real "Drafts (1)" entry that survived teardown. This predicate is the
// single source of truth for "may we persist a draft right now?".
export function shouldPersistCreateDraft(
  smartCreateOpen: boolean,
  walkthroughActive: boolean,
  meaningful: boolean,
): boolean {
  if (!smartCreateOpen) return false
  // No draft may be written while a walkthrough is active — the tutorial drives
  // the Create panel and its edits must leave zero persisted residue.
  if (walkthroughActive) return false
  return meaningful
}
